"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Phone = function Phone(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.091 2.656H6.66a2.058 2.058 0 00-2.056 2.056v10.576c0 1.136.924 2.056 2.056 2.056h6.428a2.058 2.058 0 002.056-2.056V4.712a2.052 2.052 0 00-2.053-2.056zM6.66 3.832h6.428c.484 0 .88.396.88.88v7.792H5.78V4.712a.88.88 0 01.88-.88zm6.431 12.336H6.66a.883.883 0 01-.88-.88v-1.612h8.192v1.612a.88.88 0 01-.88.88z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.874 15.42a.716.716 0 100-1.432.716.716 0 000 1.432z",
    fill: color
  }));
};
var _default = exports["default"] = Phone;